import React from 'react'
import { useSelector } from 'react-redux'
import { createNewLanguage, updateLanguage, removeLanguage } from '../store/actions'
import { getLanguages } from '../store/selectors'

import BaseData from './BaseData';

export default () => {
    const languages = useSelector(getLanguages)

    const languageEditFields = [
        {description: 'Sprache', name: 'title'},
    ]

    return (
        <BaseData 
            entities={languages} 
            createAction={createNewLanguage} 
            updateAction={updateLanguage} 
            deleteAction={removeLanguage} 
            fieldDescription={languageEditFields} 
        />
    )
}




// WEBPACK FOOTER //
// ./src/pages/Languages.js